import { useState } from 'react';
import { AdminController } from '../../../../controllers';
import constant from '../../../../utils/constant';
import { MimaToastUtil } from '../../../../components';
import { adminStore } from '../../../../stores';
import { refreshQuery } from '../../../../utils/utils';
import { useNavigate } from 'react-router-dom';

export const useDeleteProductLogic = ({ closeModal }) => {
	const navigate = useNavigate();
	const [loading, setLoading] = useState(false);
	const { businessId } = adminStore;

	const onDelete = async id => {
		setLoading(true);
		const { status, errorMessage } = await AdminController.deleteProduct(id);

		if (status === constant.Success) {
			const id = businessId;
			refreshQuery({ queryKey: [id, constant.apiQueryKey.getProducts] });
			setLoading(false);
			MimaToastUtil.success({
				message: constant.Success,
			});
			navigate(constant.Routes.Admin.Products);
			return closeModal();
		}
		setLoading(false);
		return MimaToastUtil.error({
			message: errorMessage,
		});
	};
	return { onDelete, loading };
};

export default useDeleteProductLogic;
